export default "__VITE_ASSET__rX0FrYGJ__"